import React from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { organizationLabel, readSessionUser, roleLabel } from '../utils/sessionUser';

export default function Header({ showMenu, menuOpen, onOpenMenu }) {
  const theme = useTheme();
  const user = readSessionUser();
  const organization = organizationLabel(user);
  const detail = [roleLabel(user?.tipo), organization].filter(Boolean).join(' · ');

  return (
    <Box
      component="header"
      sx={{
        height: theme.pontonow.headerHeight,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        borderBottom: `1px solid ${theme.pontonow.border}`,
        backgroundColor: theme.pontonow.canvas,
        position: 'sticky',
        top: 0,
        zIndex: theme.zIndex.appBar,
      }}
    >
      {showMenu ? (
        <IconButton
          aria-label="Abrir menu"
          aria-controls="navegacao-principal"
          aria-expanded={menuOpen ? 'true' : 'false'}
          onClick={onOpenMenu}
          sx={{ color: 'text.primary' }}
        >
          <MenuIcon />
        </IconButton>
      ) : null}
      <Typography variant="h6" component="p" sx={{ flex: 1, minWidth: 0 }} noWrap>
        PontoNow
      </Typography>
      <Box sx={{ minWidth: 0, textAlign: 'right' }}>
        <Typography variant="body2" noWrap>
          {user?.nome || 'Usuário autenticado'}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
          {detail}
        </Typography>
      </Box>
    </Box>
  );
}
